// ==============================|| C-9 — shared formatting helpers ||============================== //
// Locale-aware date/currency/number formatting, consolidated from the copies that had grown across
// the SPAs (education/shared, super-admin lib/ui, billing `money`, commerce inline). Default locale
// is the pilot's tr-TR; callers may override. Framework-agnostic, zero runtime deps.

const DEFAULT_LOCALE = 'tr-TR';

/** ISO string → short localized date+time for tables; null/empty → em dash. */
export function formatDateTime(iso: string | null | undefined, locale: string = DEFAULT_LOCALE): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' });
}

/** ISO string → medium localized date (no time); null/empty → em dash. */
export function formatDate(iso: string | null | undefined, locale: string = DEFAULT_LOCALE): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(locale, { dateStyle: 'medium' });
}

/** `datetime-local` input value → UTC ISO string (empty → null) — the inverse of a form date field. */
export function toUtcIso(value: string | null | undefined): string | null {
  return value ? new Date(value).toISOString() : null;
}

/** Amount + ISO-4217 currency → localized currency string (e.g. "₺1.234,50"). */
export function formatCurrency(amount: number, currency: string, locale: string = DEFAULT_LOCALE): string {
  return amount.toLocaleString(locale, { style: 'currency', currency });
}

/** Localized grouped number (e.g. "1.234.567"). */
export function formatNumber(value: number, locale: string = DEFAULT_LOCALE): string {
  return value.toLocaleString(locale);
}
